import { render, staticRenderFns } from "./HighlightResult.vue?vue&type=template&id=64c5d695"
import script from "./HighlightResult.vue?vue&type=script&lang=js"
export * from "./HighlightResult.vue?vue&type=script&lang=js"
import style0 from "./HighlightResult.vue?vue&type=style&index=0&id=64c5d695&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c5d695')) {
      api.createRecord('64c5d695', component.options)
    } else {
      api.reload('64c5d695', component.options)
    }
    module.hot.accept("./HighlightResult.vue?vue&type=template&id=64c5d695", function () {
      api.rerender('64c5d695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/HighlightResult.vue"
export default component.exports